<template>
    <div class="wl-container">
        <div class="updateGuide" v-if="updateGuide"></div>
        <NewComments :messageType="messageType" :siteId="siteId"></NewComments>
        <div class="wl-content-container content-with-comments">
            <template>
                <!--  tabs-->
                <div class="tab-row">
                    <ul class="tab-cls">
                        <li :class="activeTab === '0' ? 'active' : ''" @click="activeChange('0')">
                            {{ $t('PAGE_EXCHANGE_TAB1') }}
                            <!-- <GuidanceTooltip
                                v-show="getUser.userType == '1'"
                                class="GuidanceTooltip"
                                backgroundColor="none"
                                yellowIcon
                                :content="$t('exchange_tip_kp')"
                                size="17"
                                iconSize="15"
                                :jumpLink="$t('exchange_tip_link_kp')"
                            ></GuidanceTooltip> -->
                        </li>
                        <li
                            v-show="enableITU || activeTab == '3'"
                            :class="[activeTab === '3' ? 'active' : '', updateGuide && updateGuideStep === 2 ? 'updateGuideTab' : '']"
                            @click="activeChange('3')"
                        >
                            {{ $t('PAGE_EXCHANGE_TAB4') }}
                            <GuidanceTooltip
                                class="GuidanceTooltip"
                                v-show="getUser.userType == '1'"
                                backgroundColor="none"
                                yellowIcon
                                :content="$t('ITU_tip')"
                                size="17"
                                iconSize="15"
                                :jumpLink="$t('ITU_tip_link')"
                            ></GuidanceTooltip>
                            <!--更新指导 start-->
                            <div class="updateGuideTip" v-if="updateGuide && updateGuideStep === 2">
                                <div class="margin-bottom-10">2/2</div>
                                <div class="margin-bottom-10">{{ $t('ITUnderstanding') }}</div>
                                <el-button @click="gotItClick" class="guide-btn">{{ $t('gotIt') }}</el-button>
                            </div>
                        </li>
                        <!--更新指导 end-->
                    </ul>
                    <div class="btn">
                        <span :class="['clear-filter', clearFilterActive ? 'clear-filter-active' : '']" @click="clearAll">
                            <img src="@/assets/img/icon-screen.svg" class="table-setting-icon" />
                            {{ $t('clear_filter') }}
                        </span>
                    </div>
                </div>
                <!-- 按钮行 -->
                <div class="bar-row" v-if="activeTab === '0'">
                    <div class="left">
                        <el-button
                            @click="toogleMultiSelect('download')"
                            :disabled="!hasPermission('download') || (chooseable && !!multiChoose.mode)"
                            icon="el-icon-download"
                            class="wl-green"
                        >
                            {{ $t('BATCH_DOWNLOAD') }}
			<GuidanceTooltip
			  backgroundColor="none"
              yellowIcon
              :size="20"
              :iconSize="14"
              :content="$t('setFileAndDownloadTipHtml')"
              :jumpLink="$t('setFileAndDownloadTipLink')"
      
          ></GuidanceTooltip>
                        </el-button>
                        <el-button
                            @click="toogleMultiSelect('delete')"
                            :disabled="chooseable && !!multiChoose.mode"
                            v-if="activeTab === '0' && isKpmgUser()"
                            class="wl-green svg-btn"
                        >
                            <img src="@/assets/img/icon-batchdeletion.svg" width="100%" class="btn-icon" />
                            {{ $t('patch_delete') }}
                        </el-button>
                    </div>
                    <div class="wl-search-bar">
                        <el-tooltip class="item" effect="dark" placement="bottom">
                            <div slot="content" style="width: 590px" v-html="$t('JOINT_WORKING_ADD_TIPS')" />
                            <span>
                                <el-button
                                    icon="el-icon-plus"
                                    @click="toggleAddVisible"
                                    v-if="isKpmgUser()"
                                    :disabled="!(kpRoleBind && kpRoleBind.length > 0)"
                                    class="wl-green mgr10"
                                    >{{ $t('COMMON_ADD') }}
                                </el-button>
                            </span>
                        </el-tooltip>
                        <el-button
                            @click="toogleMultiSelect('email')"
                            :disabled="chooseable && !!multiChoose.mode"
                            v-if="isKpmgUser()"
                            class="wl-green"
                            icon="el-icon-message"
                        >
                            {{ $t(`PAGE_CLIENTUSER_EMAIL_EXCHANGE_TAB${activeTab}`) }}
                        </el-button>
                        <el-button @click="exportList" :disabled="!hasPermission('download')" class="wl-green svg-btn">
                            <img src="@/assets/img/icon-export.svg" width="100%" class="btn-icon" />
                            {{ $t('Export_exchange_Items') }}
                        </el-button>
                        <el-button
                            @click="toogleMultiSelect('export')"
                            :disabled="!hasPermission('download') || (chooseable && !!multiChoose.mode)"
                            class="wl-green svg-btn"
                        >
                            <img src="@/assets/img/icon-export.svg" width="100%" class="btn-icon" />
                            {{ $t('BATCH_export') }}
                        </el-button>
                    </div>
                </div>

                <!-- ITA组件，单独放出去 -->
                <ITAIndex
                    ref="ITA"
                    class="ITA-container"
                    v-if="activeTab === '3'"
                    :entityData="entityData"
                    :toogleClearFilterActive="toogleItuClearFilterActive"
                    @openEntity="openEntity"
                ></ITAIndex>
                <!-- 表格 -------------------------------start---------------->
                <div v-if="activeTab === '0'" :class="['table-container-wrapper', chooseable ? 'show-table-bottom-operate' : '']">
                    <!--更新指导 start-->
                    <div
                        class="updateGuideTitle"
                        v-if="updateGuide && updateGuideStep === 1"
                        :style="{ height: `${updateGuideTitleHeight}px` }"
                    >
                        <div class="updateGuideTip" :style="{ top: `${updateGuideTitleHeight + 10}px` }">
                            <div class="margin-bottom-10">{{ enableITU ? '1/2' : '1/1' }}</div>
                            <div class="margin-bottom-10">{{ $t('filterFunction') }}</div>
                            <el-button v-if="enableITU" @click.stop="nextClick" class="guide-btn">{{ $t('next') }}</el-button>
                            <el-button v-else @click="gotItClick" class="guide-btn">{{ $t('gotIt') }}</el-button>
                        </div>
                    </div>
                    <!--更新指导 end-->
                    <el-table
                        height="100%"
                        v-loading="loading"
                        :data="data"
                        @select-all="(e) => handleSelectAll(e, data)"
                        @select="handleSelect"
                        border
                        ref="exchangeTable"
                        class="exchange-table"
                        :header-cell-class-name="updateGuideClass"
                        stripe
                        :empty-text="$t('TABLE_NO_DATA')"
                    >
                        <el-table-column v-if="chooseable" align="center" type="selection" width="50"> </el-table-column>

                        <el-table-column prop="entityName" width="400" :key="1" show-overflow-tooltip :label="$t('TABLE_HEAD_EntityList')">
                            <template slot="header" slot-scope="scope">
                                <span class="el-dropdown-link">
                                    {{ $t('TABLE_HEAD_EntityList') }}
                                    <i
                                        :class="[
                                            'el-icon-arrow-down',
                                            'table-header-edit-cls',
                                            'th-header-edit',
                                            getEntityIds && getEntityIds.length > 0 && !getEntityIdsSelectAllTag ? 'el-icon-arrow-down-active' : ''
                                            ]"
                                        :title="$t('Filter_per_Entity')"
                                        @click="openEntity"
                                    ></i>
                                </span>
                            </template>
                        </el-table-column>

                        <el-table-column :key="2" prop="category" min-width="150" align="left" show-overflow-tooltip>
                            <template #header>
                                <div class="header-with-popup">
                                    {{ $t('TABLE_HEAD_Category') }}
                                    <MultiSelectPopver
                                        :hidePopperSearch="hidePopperSearch"
                                        :value.sync="searchForm.category"
                                        labelKey="label"
                                        valueKey="value"
                                        :inputFilterKey="['label', 'value']"
                                        :options="categoryOptions"
                                    ></MultiSelectPopver>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column :key="6" prop="fileList" width="200" align="center">
                            <template #header>
                                <div class="header-with-popup">
                                    {{ $t('TABLE_HEADER_fileNameList') }}
                                    <el-popover placement="bottom" trigger="click" :visible-arrow="false" @hide="hidePopperSearch">
                                        <template #reference>
                                            <div class="th-filter-down">
                                                <i
                                                    :class="[
                                                        'el-icon-arrow-down',
                                                        searchForm.searchContent ? 'el-icon-arrow-down-active' : ''
                                                    ]"
                                                ></i>
                                            </div>
                                        </template>
                                        <template>
                                            <el-input
                                                class="input-with-select"
                                                v-model="searchForm.searchContent"
                                                size="medium"
                                                :placeholder="$t('fileNameKeyword')"
                                                clearable
                                            ></el-input>
                                        </template>
                                    </el-popover>
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <span
                                    class="file-number-hint"
                                    @click="toogleFileDetailVisible(scope.row)"
                                    v-if="scope.row.fileList && scope.row.fileList.length > 0"
                                >
                                    {{ scope.row.fileList.length }}
                                </span>
                            </template>
                        </el-table-column>

                        <el-table-column :key="7" align="center" width="150" :label="$t('COMMON_UPLOAD')">
                            <template slot-scope="scope">
                                <i
                                    v-if="!isIE"
                                    :class="[
                                        'el-icon-upload',
                                        !hasPermission('upload') ? 'wl-icon-messageBoardNull' : 'wl-icon-messageBoard'
                                    ]"
                                    @click="toogleUploadVisible(scope.row)"
                                ></i>
                                <el-button
                                    v-else
                                    @click="toogleUploadVisible(scope.row)"
                                    size="mini"
                                    :disabled="!hasPermission('upload')"
                                    :class="['el-icon-upload', !hasPermission('upload') ? 'upload-forbid' : 'wl-green']"
                                    >{{ $t('COMMON_UPLOAD') }}</el-button
                                >
                            </template>
                        </el-table-column>
                        <el-table-column width="180" align="center" :label="$t('TABLE_HEAD_COMMENTS')" :key="8">
                            <template #header>
                                <div class="header-with-popup">
                                    {{ $t('TABLE_HEAD_COMMENTS') }}
                                    <DatePickerPopover
                                        :value.sync="searchForm.commentDate"
                                        :hidePopperSearch="hidePopperSearch"
                                    ></DatePickerPopover>
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <div class="flex  item-center justify-center">
                                    <i
                                        :class="[
                                            scope.row.todayCommentCount > 0 ? 'wl-icon-messageBoard' : 'wl-icon-messageBoardNull',
                                            'el-icon-s-comment'
                                        ]"
                                        @click="toogleMessageBoardVisible(scope.row)"
                                    ></i>
                                    <span v-if="scope.row.todayCommentCount"> 
                                        <span class="message-today">{{ scope.row.todayCommentCount }}</span>
                                        <span>/</span> 
                                    </span>
                                    <span v-if="scope.row.messageNum > 0"> {{ scope.row.messageNum }}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column :key="9" width="170" v-if="isKpmgUser()" align="center" :label="$t('TABLE_HEADER_Action')">
                            <template slot-scope="scope">
                                <div>
                                    <i class="el-icon-edit-outline wl-icon-edit" @click="onEdit(scope.row)"></i>
                                    <i style="margin-left: 10px" class="el-icon-delete wl-icon-delete" @click="onDelete(scope.row)"></i>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="footer-btn" v-if="chooseable&&activeTab==='0'">
                    <el-button class="cancel-btn" @click="cancelChoose" :disabled="!chooseable">
                        {{ $t('btn_cancel') }}
                    </el-button>
                    <el-button
                        @click="tooglebatchDownLoad('download')"
                        :disabled="chooseable && hasSelectedList.length == 0"
                        class="wl-green"
                        v-if="chooseable && multiChoose.mode == 'download'"
                    >
                        {{ $t('COMMON_DOWNLOAD') }}
                    </el-button>
                    <el-button
                        @click="toogleEmailVisible"
                        :disabled="chooseable && hasSelectedList.length == 0"
                        v-if="isKpmgUser() && chooseable && multiChoose.mode == 'email'"
                        class="wl-green"
                    >
                        {{ $t(`PAGE_CLIENTUSER_EMAIL_EXCHANGE_TAB${activeTab}`) }}
                    </el-button>
                    <el-button
                        @click="onBatchDelete"
                        :disabled="chooseable && hasSelectedList.length == 0"
                        v-if="isKpmgUser() && chooseable && multiChoose.mode == 'delete'"
                        class="wl-green"
                    >
                        {{ $t('COMMON_DELETE') }}
                    </el-button>
                    <el-button
                        @click="tooglebatchDownLoad('export')"
                        :disabled="chooseable && hasSelectedList.length == 0"
                        class="wl-green"
                        v-if="chooseable && multiChoose.mode == 'export'"
                    >
                        {{ $t('BATCH_export') }}
                    </el-button>
                </div>
                <!------------------表格------------------------end-------------->
                <!-- 分页 -->
                <el-pagination
                    v-if="activeTab === '0'"
                    class="wl-pagination"
                    :current-page="pagination.pageNum"
                    :page-size="pagination.pageSize"
                    @current-change="onCurrentPageChange"
                    @size-change="onSizeChange"
                    layout="prev, pager, next, slot, total"
                    :total="pagination.total"
                >
                    <span>
                        <el-select v-model="pagination.pageSize" @change="onSizeChange">
                            <el-option v-for="item in pageOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                        </el-select>
                    </span>
                </el-pagination>
            </template>
        </div>
        <!-- 新增/编辑的弹框 -->
        <exchange-add
            v-if="addVisible"
            :saveLoading="btnLoading"
            :initData="initData"
            :onCancel="toggleAddVisible"
            :onAdd="saveEntityCategory"
        />

        <!-- email-->
        <exchange-email v-if="addVisibleEmail" :saveLoading="emailBtnLoading" :onCancel="toogleEmailVisible" :onAdd="sendEmail" />

        <!--upload弹窗-->
        <upload v-if="uploadVisible" :initData="rowData" :onCancel="closeUploadVisble" :onAdd="uploadSuccess" />

        <!--        留言-->
        <messageBoard v-if="messageBoardVisible" :initData="rowData" :onCancel="toogleMessageBoardVisible" :onAdd="getTableList" :messageType="messageType" :siteId="siteId"/>

        <!--        文件详情-->
        <file-detail
            v-if="fileDetailVisbile"
            :id="rowData.id"
            :tableData="rowData.fileList"
            :curUserName="curUserName"
            :downloadAble="downloadAble"
            :onCancel="toogleFileDetailVisible"
            @on-file-download="downloadFileDetail"
        />

        <!--        下载确认-->
        <file-confirm-modal
            :fileDownloading="fileDownloading"
            ref="FileConfirmModal"
            :groupList="hasSelectedList"
            @ok="downloadMultipleFiles"
            @on-file-download="downloadFileDetail"
            @updateMultipleSelection="updateMultipleSelection"
            :curUserName="curUserName"
            :downloadAble="downloadAble"
            :mode="downloadDialogMode"
        />

        <!--        右侧抽屉-->
        <entity :onAdd="onDrawClick" :entityData="entityData" ref="entityRef" />
    </div>
</template>

<script>
import exchangeAdd from './exchange-add'
import upload from './upload'
import { mapGetters } from 'vuex'
import messageBoard from './messageBoard'
import exchangeEmail from './exchange-email'
import fileDetail from './file-detail'
import API from '@/api'
import { formatFileSize, isIE, loading, dateFormat } from '@/utils'
import FileConfirmModal from './file-confirm-modal'
import Entity from './entity'
import { exportFileLogXls } from '@/utils/exportTable'
import { userPermission } from '@/mixins/userPermission.js'
import batchSelectTableMixins from '@/mixins/batchSelectTableMixins.js'
import allCategory from './allCategory'
import windowConfig from '@/utils/windowConfig'
import MultiSelectPopver from '@/components/common/MultiSelectPopver.vue'
import GuidanceTooltip from '@/components/common/GuidanceTooltip.vue'
import ITAIndex from './ITA/index.vue'
import { downloadSingleFile, downloadBatchFiles } from '@/utils/useDownload'
import { treeToList } from '@/utils/formatTree'
import NewComments from '@/components/common/NewComments.vue'
import DatePickerPopover from '@/components/common/DatePickerPopover.vue'

export default {
    name: 'index',
    components: {
        exchangeAdd,
        upload,
        messageBoard,
        exchangeEmail,
        fileDetail,
        FileConfirmModal,
        Entity,
        MultiSelectPopver,
        GuidanceTooltip,
        ITAIndex,
        NewComments,
        DatePickerPopover
    },
    computed: {
        enableITU() {
            if (this.getUser.userType == '1') {
                // return this.roleItuGeneral == 1
                return true
            } else {
                // return this.roleItuGeneral == 1 &&
                return this.roleItu
            }
        },
        ...mapGetters('common', {
            getUser: 'getUser',
            getSite: 'getSite',
            getEntityIds: 'getEntityIds',
            getIfKpHasAccess: 'getIfKpHasAccess',
            getEntityIdsSelectAllTag: 'getEntityIdsSelectAllTag',
        }),
        entityDataTotalSize(){
            const flatTree = treeToList(this.entityData).filter(item=>!item.disabled)
            return flatTree.length
        },
        clearFilterActive() {
            const exchangeFilterActive = (this.searchForm.category && this.searchForm.category.length > 0) ||
                    (this.searchForm.statusList && this.searchForm.statusList.length > 0) || this.searchForm.dueDay || this.searchForm.chargeUser ||
                    (this.searchForm.searchContent && this.searchForm.searchContent !== '')||(this.searchForm.commentDate && this.searchForm.commentDate[0])
            const tableFilters = this.activeTab === '0' ? exchangeFilterActive : this.ituClearFilterActive
            
            const entityFilterActive = this.getEntityIds.length!==this.entityDataTotalSize
            return tableFilters || entityFilterActive
        },
        siteId(){
            return this.getSite.siteId
        },
        messageType(){
            return this.activeTab === '0'?'5':''
        }
    },
    mixins: [userPermission, batchSelectTableMixins],
    data() {
        return {
            pageOptions: [
                { label: '10/' + this.$t('page') + this.$t('page_tip'), value: 10 },
                { label: '50/' + this.$t('page'), value: 50 },
                { label: '100/' + this.$t('page'), value: 100 }
            ],
            searchForm: {
                category: [],
                statusList: null,
                dueDay: null,
                chargeUser: null,
                searchContent: '',
                commentDate:[]
            },
            optionLoading: false,
            categoryOptions: [],
            chooseable: false,
            activeTab: '0',
            entityData: [],
            allEntityIds: [],
            data: [],
            downloadDialogMode: '', // download | export
            pagination: {
                pageNum: 1,
                pageSize: 10,
                total: 0
            },
            loading: false,
            btnLoading: false,
            addVisible: false,
            emailBtnLoading: false,
            addVisibleEmail: false,
            emailBtnDisabled: true,
            uploadVisible: false,
            messageBoardVisible: false,
            fileDetailVisbile: false,
            rowData: {},
            initData: {}, //编辑/新增传递参数
            fileDownloading: false,
            curUserName: '',
            downloadAble: false,
            kpRoleBind: [], //当前kp人员有无绑定角色信息
            multiChoose: {
                /* 是否可多选的状态在上层 */
                /* 已选中的数组在上层 */
                mode: '' // download | email
            },
            allCategory: allCategory,
            isIE: false,
            roleItu: false,
            roleItuGeneral: 0,
            updateGuide: false,
            updateGuideStep: 0,
            ituClearFilterActive: false,
            updateGuideTitleHeight: 0
        }
    },
    watch: {
        hasSelectedList(newVal, oldVal) {
            if (newVal.length > 0) {
                this.emailBtnDisabled = false
            } else {
                this.emailBtnDisabled = true
            }
        },
    },
    async mounted() {
        window.onresize = () => {
            this.updateGuideTitleHeight = document.getElementsByClassName('el-table__header-wrapper')[0].clientHeight
             
        }
        setTimeout(() => {
            this.updateGuideTitleHeight = document.getElementsByClassName('el-table__header-wrapper')[0].clientHeight
             
        }, 500)

        const tabIndex = this.$route.query.tabIndex
        if (tabIndex && tabIndex > 0) {
            // await this.activeChange(tabIndex)
            this.activeTab = tabIndex
        }
        if (this.getUser.userType === '1') {
            this.getKpRolesBind()
        }
        // this.selectStatus()
        // this.selectKPOwner()
        // await this.getGeneralTile()
        await this.queryLimits()
        await this.getUserEntity()
        await this.getCategoryOptions()
        await this.getBehavior()
        await this.activeChange(this.activeTab)

        // await this.getTableList()
        this.isIE = isIE()
    },
    methods: {
        toogleItuClearFilterActive(v) {
            this.ituClearFilterActive = v
        },
        hidePopperSearch() {
            this.pagination = {
                pageNum: 1,
                pageSize: 10,
                total: 0
            }
            this.getTableList()
        },
        exportList() {
            let params = {
                siteId: this.getSite.siteId,
                allEntityIdList: this.getEntityIds,
                entityIdList: this.getEntityIds,
                onlyKpmg: this.activeTab,
                ...this.pagination,
                ...this.searchForm
            }
            const _loading = loading()
            _loading.download()
            API.exchange
                .exportList(params)
                .then((res) => {
                    if (/application\/json/.test(res.data.type)) {
                        let reader = new FileReader()
                        reader.onload = (e) => {
                            if (e.target.readyState === 2) {
                                let resJson = {}
                                resJson = JSON.parse(e.target.result)
                                this.$message.error({ duration: 5000, message: this.$t(resJson.code) })
                            }
                        }
                        reader.readAsText(res.data)
                    }
                    if (/application\/octet-stream/.test(res.data.type)) {
                        let blob = new Blob([res.data])
                        const filename = decodeURI(res.headers['content-disposition'].replace('attachment; filename=', ''))
                        if (isIE()) {
                            navigator.msSaveBlob(blob, filename)
                        } else {
                            let url = window.URL.createObjectURL(blob)
                            let link = document.createElement('a')
                            link.style.display = 'none'
                            link.href = url
                            link.setAttribute('download', filename)
                            document.body.appendChild(link)
                            link.click()
                        }
                    }
                })
                .catch((e) => {})
                .finally(() => {
                    _loading.close()
                })
        },
        onBatchDelete() {
            this.$confirm(this.$t('msg_delete_sure'), {
                confirmButtonText: this.$t('btn_confirm'),
                cancelButtonText: this.$t('btn_cancel'),
                type: 'warning',
                cancelButtonClass: 'cancel-btn',
                confirmButtonClass: 'wl-green'
            }).then(() => {
                this.loading = true
                API.exchange
                    .batchDelete({
                        ids: this.hasSelectedList.map((v) => `${v.id}`)
                    })
                    .then((res) => {
                        if (res.code == '1') {
                            this.pagination.pageNum = 1
                            this.getTableList()
                            this.$message({
                                type: 'success',
                                message: this.$t('msg_success')
                            })
                            this.$refs.exchangeTable.clearSelection()
                            this.chooseable = false
                        } else {
                            this.$message.error(this.$t(res.code))
                        }
                    })
                    .catch((e) => {
                        console.error(e)
                        this.$message.error(this.$t('SYS_USER_003'))
                    })
                    .finally(() => {
                        this.loading = false
                        this.$refs.FileConfirmModal.visible = false
                        this.$refs.exchangeTable.clearSelection()
                        this.chooseable = false
                        this.$refs.exchangeTable.clearSelection()
                    })
            })
        },
        toogleMultiSelect(mode) {
            this.multiChoose = {
                mode: mode
            }
            this.chooseable = true
        },
        getKpRolesBind() {
            const params = {
                siteId: this.getSite.siteId,
                pageNum: 1,
                pageSize: 99999,
                queryParam: this.getUser.userName,
                userType: '1' //string 3 代表compoent/ 1代表member
            }
            API.kpTMember.queryMemberList(params).then((res) => {
                if (res.code === '1' && res.data.memberList && res.data.memberList.records && res.data.memberList.records.length > 0) {
                    this.kpRoleBind = res.data.memberList.records[0].roleIdList
                }
            })
        },
        async getCategoryOptions(query) {
            this.optionLoading = true
            let params = {
                category: query,
                siteId: this.getSite.siteId,
                onlyKpmg: this.activeTab
            }
            let { code, data } = await API.exchange.searchCategory(params)
            if (code == '1') {
                this.categoryOptions =
                    data.map((v) => {
                        const findCategory = this.allCategory[0].find((vv) => vv.realValue === v)
                        const label = !!findCategory ? this.$t(findCategory.value) : v
                        const value = !!findCategory ? findCategory.realValue : v
                        return {
                            label,
                            value
                        }
                    }) || []
                this.optionLoading = false
            }
        },
        cancelChoose() {
            this.$refs.exchangeTable.clearSelection()
            this.chooseable = false
        },
        // 查询当前站点downloadable
        async queryLimits() {
            const { code, data } = await API.clientUser.getSiteConfig({ param: this.getSite.siteId })
            if (code == '1') {
                this.downloadAble = !!data.downloadable
                this.roleItu = data.roleItu == '1'
            } else {
                this.$message.error(this.$t(code))
            }
            // 当前文件uploadby
            let userType = this.getUser.userType
            if (userType == '1') {
                this.curUserName = this.getUser.userName
            } else {
                this.curUserName = this.getUser.userAccount
            }
        },
        getGeneralTile() {
            API.general
                .siteTilesGeneral({ siteId: this.getSite.siteId })
                .then((res) => {
                    if (res.code == '1') {
                        this.roleItuGeneral = res.data.ituFlag
                    } else {
                        this.$message({
                            type: 'error',
                            message: this.$t(res.code)
                        })
                    }
                })
                .catch((e) => {
                    console.error(e)
                    this.$message.error(this.$t('SYS_USER_003'))
                })
                .finally((e) => {})
        },
        isKpmgUser() {
            return this.getUser.userType === '1'
        },
        // 页码
        onCurrentPageChange(val) {
            this.pagination.pageNum = val
            this.getTableList()
        },
        onSizeChange(val) {
            this.pagination.pageNum = 1
            this.pagination.pageSize = val
            this.getTableList()
        },
        async activeChange(val) {
             
            this.activeTab = val
            if (val === '0') {
                this.searchForm = {
                    category: [],
                    statusList: [],
                    dueDay: null,
                    chargeUser: null,
                    commentDate:[]
                }
                this.chooseable = false
                await this.getTableList()
            }
        },
        async clearAll() {
            if (this.activeTab == '3') {
                await this.getUserEntity()
                this.$refs.ITA.onClearFilter()
            } else {
                this.searchForm = {
                    category: [],
                    statusList: [],
                    dueDay: null,
                    chargeUser: null,
                    commentDate:[]
                }
                await this.getUserEntity()
                await this.getTableList()
            }
        },
        // 获取表格信息
        async getTableList() {
            if (!this.getIfKpHasAccess) return
            // 如果是kp组成部分人员 && general 中的集团审计小组 关闭 => 页面空白
            let params = {
                siteId: this.getSite.siteId,
                allEntityIdList: this.getEntityIds,
                entityIdList: this.getEntityIds,
                onlyKpmg: this.activeTab,
                ...this.pagination,
                ...this.searchForm,
                category: this.searchForm.category ? this.searchForm.category : [],
                startCommentDate: this.searchForm.commentDate && this.searchForm.commentDate[0] ? dateFormat(new Date(this.searchForm.commentDate[0]), 'yyyy-MM-dd') : null,
                endCommentDate: this.searchForm.commentDate && this.searchForm.commentDate[1] ? dateFormat(new Date(this.searchForm.commentDate[1]), 'yyyy-MM-dd') : null,
            }
            this.loading = true
            const { code, data } = await API.exchange.exchangeQuery(params)
            if (code === '1') {
                this.data = !data.records
                    ? []
                    : data.records.map((v) => {
                          const findCategory = this.allCategory[0] ? this.allCategory[0].find((vv) => vv.realValue === v.category) : null
                          v.category = !!findCategory ? this.$t(findCategory.value) : v.category

                          v.oriStatus = v.status
                          return v
                      })
                this.pagination.total = data.total
                // 回显已选中的
                this.handleEchoData('exchangeTable', this.data)
            } else {
                this.$message.error(this.$t(code))
            }
            this.loading = false
        },
        // 初始获取右侧entity信息
        getUserEntity: async function () {
            const { code, data } = await API.common.queryUserEntity({ siteId: this.getSite.siteId, exchangeType: '0', menuId:'20' ,userType: this.getUser.userType })
            if (code == '1') {
                this.entityData = [data]
                this.allEntityIds = []
                this.getAllIds(this.entityData[0])
                this.$store.commit('common/setEntityIds', this.allEntityIds)
            } else {
                this.$message.error(this.$t(code))
            }
        },
        // 获取所有node的id && 默认选中
        getAllIds(data) {
            if (!data.disabled) {
                data.checked = true
                this.allEntityIds.push(data.id)
            }
            if (data.childEntity.length > 0) {
                data.childEntity.forEach((child) => this.getAllIds(child))
            }
        },
        // 新增
        toggleAddVisible() {
            this.initData = {}
            this.addVisible = !this.addVisible
        },
        // 编辑
        onEdit(row) {
            this.initData = row
            this.addVisible = !this.addVisible
        },
        // 新增---保存
        async saveEntityCategory(form) {
            if (form.id) {
                form.onlyKpmg = this.activeTab
                const { code, data } = await API.exchange.exchangeUpdate(form)
                try {
                    if (code == '1') {
                        this.$message.success(this.$t('msg_success'))
                    } else {
                        this.$message.error(this.$t(code))
                    }
                } catch (e) {
                    this.$message.error(e)
                }
            } else {
                const params = {
                    siteId: this.getSite.siteId,
                    entityIdList: form.entityIdList,
                    onlyKpmg: this.activeTab,
                    category: form.category
                }
                const { code, data } = await API.exchange.exchangeAdd(params)
                try {
                    if (code == '1') {
                        this.$message.success(this.$t('msg_success'))
                    } else {
                        this.$message.error(this.$t(code))
                    }
                } catch (e) {
                    this.$message.error(e)
                }
            }
            this.pagination.pageNum = 1
            await this.getTableList()
            await this.getCategoryOptions()
            this.addVisible = !this.addVisible
        },
        // 删除
        onDelete(row) {
            this.$confirm(this.$t('msg_delete_sure'), this.$t('COMMON_TIP'), {
                confirmButtonText: this.$t('btn_confirm'),
                cancelButtonText: this.$t('btn_cancel'),
                type: 'warning',
                cancelButtonClass: 'cancel-btn',
                confirmButtonClass: 'wl-green'
            })
                .then(() => {
                    API.exchange.exchangeDel(row.id).then((res) => {
                        if (res.code == '1') {
                            this.$message.success(this.$t('msg_success'))
                        } else {
                            this.$message.error(this.$t(code))
                        }
                        this.getTableList()
                    })
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: this.$t('CANCLE_OPERATION')
                    })
                })
        },
        // upload
        toogleUploadVisible(row) {
            if (!this.hasPermission('upload')) {
                return
            }
            this.rowData = row
            this.uploadVisible = !this.uploadVisible
        },
        closeUploadVisble() {
            this.getTableList()
            this.uploadVisible = !this.uploadVisible
        },
        async uploadSuccess() {
            await this.getTableList()
            this.rowData = this.data.filter((item) => item.id === this.rowData.id)[0]
        },
        // 留言
        toogleMessageBoardVisible(row) {
            this.messageBoardVisible = !this.messageBoardVisible
            this.rowData = row
        },
        // send email
        toogleEmailVisible() {
            this.addVisibleEmail = !this.addVisibleEmail
        },
        async sendEmail(emailList, ccList) {
            var info = []
            this.hasSelectedList.forEach((item) => {
                let fileList = []
                if (item.fileList && item.fileList.length > 0) {
                    let len = item.fileList.length
                    item.fileList.forEach((fileItem) => {
                        fileList.push({ fileId: fileItem.fileId, fileName: fileItem.name })
                    })
                }
                info.push({ entityName: item.entityName, category: item.category, fileList: fileList })
            })
            let param = {
                siteEntityList: info,
                sendUserIdList: emailList,
                siteId: this.getSite.siteId,
                source: this.activeTab,
                ccUserIdList: ccList
            }
            const { code, data } = await API.exchange.sendEmail(param)
            if (code == '1') {
                this.$message.success(this.$t('msg_success'))
                this.$refs.exchangeTable.clearSelection()
                this.chooseable = false
            } else {
                this.$message.error(this.$t(code))
            }
            this.addVisibleEmail = !this.addVisibleEmail
        },
        // 文件详情
        toogleFileDetailVisible(row) {
            this.rowData = row
            this.fileDetailVisbile = !this.fileDetailVisbile
        },
        updateMultipleSelection(row) {
            this.hasSelectedList = row
        },
        // 下载
        downloadFileDetail(v) {
            if (v.length > 0) {
                const list = []
                v.forEach((i, n) => {
                    list.push({
                        id: i.id,
                        fileId: i.fileId,
                        siteEntityId: i.id,
                        siteId: this.getSite.siteId,
                        source: 'exchange',
                        fileName: i.name
                    })
                })
                if (list.length === 0) {
                    this.$message.error(this.$t('FILE_LIST_EMPTY_ALERT'))
                    return
                }
                if (list.length === 1) {
                    this.downloadFileListSingle(list[0])
                }

                this.$refs.exchangeTable.clearSelection()
                this.chooseable = false
            }
        },
        async downloadFileListSingle({ siteId, fileId, source, siteEntityId, fileName }) {
            try {
                this.fileDownloading = true
                const downRes = await API.pbc.checkDownloadRight({ siteId, source, siteEntityId })
                if (downRes.code === '1') {
                    const paramsdata = {
                        siteId,
                        id: siteEntityId,
                        tempToken: downRes.data,
                        fileId: fileId,
                        source
                    }
                    downloadSingleFile(paramsdata)
                }
            } catch (e) {
            } finally {
                this.fileDownloading = false
                this.$refs.FileConfirmModal.visible = false
                this.$refs.exchangeTable.clearSelection()
                this.chooseable = false
            }
        },

        // 批量下载页面
        tooglebatchDownLoad(mode) {
            this.downloadDialogMode = mode
            if (this.hasSelectedList.length > 0) {
                let list = []
                this.hasSelectedList.forEach((item) => {
                    if (item.fileList && item.fileList.length > 0) {
                        item.fileList.forEach((f) => {
                            if (
                                !(
                                    this.getUser.userType === '2' &&
                                    !this.downloadAble &&
                                    f.uploadBy &&
                                    f.uploadBy.indexOf('@') !== -1 &&
                                    f.uploadBy.indexOf(this.curUserName) == -1
                                )
                            ) {
                                list.push({
                                    rowId: item.id,
                                    fileName: f.name,
                                    fileId: f.fileId,
                                    bindId: item.id,
                                    siteId: this.getSite.siteId,
                                    source: 'exchange'
                                })
                            }
                        })
                    }
                })
                if (list.length === 0) {
                    this.$message.error(this.$t('FILE_LIST_EMPTY_ALERT'))
                    return
                } else if (list.length === 1) {
                    if (mode == 'download') {
                        this.downloadFileListSingle({
                            siteId: this.getSite.siteId,
                            fileId: list[0].fileId,
                            source: 'exchange',
                            siteEntityId: list[0].rowId
                        })
                    } else if (mode == 'export') {
                        this.$refs.FileConfirmModal.visible = true
                    }
                } else {
                    this.$refs.FileConfirmModal.visible = true
                }
            }
        },
        // 批量下载
        downloadMultipleFiles(rows) {
            if (this.downloadDialogMode == 'download') {
                if (rows.length === 1) {
                    const { rowId, name, fileId } = rows[0]
                    this.downloadFileListSingle({ siteId: this.getSite.siteId, fileId: fileId, source: 'exchange', siteEntityId: rowId })
                } else {
                    let size = 0
                    const list = rows.map((row) => {
                        size += parseInt(row.size || 0)
                        return {
                            siteEntityId: row.rowId,
                            siteId: this.getSite.siteId,
                            fileId: row.fileId,
                            source: 'exchange'
                        }
                    })
                    if (size > windowConfig.download.size) {
                        this.$confirm(
                            this.$t('largeSizeFileAlertContent', { size: formatFileSize(windowConfig.download.size) }),
                            this.$t('largeSizeFileAlertTitle'),
                            {
                                distinguishCancelAndClose: true,
                                showConfirmButton: false,
                                cancelButtonText: this.$t('btn_ok'),
                                cancelButtonClass: 'wl-green',
                            }
                        ).then(() => {})
                    } else {
                        this.downloadBatchList({ list },size)
                    }
                }
            } else if (this.downloadDialogMode == 'export') {
                exportFileLogXls([
                    // 标题行
                    [
                        this.$t('TABLE_HEADER_entityList'),
                        this.$t('TABLE_HEAD_Category'),
                        this.$t('DOWNLOAD_FILE_NAME'),
                        this.$t('DOWNLOAD_SIZE'),
                        this.$t('DOWNLOAD_TIME'),
                        this.$t('DOWNLOAD_BY'),
                        this.$t('UPLOAD_TIME'),
                        this.$t('UPLOAD_BY'),
                        this.$t('HISTORY')
                    ],
                    ...rows.map((v) => {
                        return [
                            v.entityName ? v.entityName : '',
                            v.category ? v.category : '',
                            v.name ? v.name : '',
                            v.size ? formatFileSize(v.size) : '0',
                            v.downloadDate ? v.downloadDate : '',
                            v.downloadBy ? v.downloadBy : '',
                            v.uploadDate ? v.uploadDate : '',
                            v.uploadBy ? v.uploadBy : '',
                            v.hasHistory ? v.hasHistory : ''
                        ]
                    })
                ],`Joint Working _ Files Sharing with Client _ files records@${dateFormat(new Date(), 'yyyyMMdd')}`)

                this.$refs.FileConfirmModal.visible = false
                this.$refs.exchangeTable.clearSelection()
                this.chooseable = false
            }
        },
        //批量下载
        async downloadBatchList(params,size) {
             
            try {
                this.fileDownloading = true
                const downRes = await API.exchange.checkBatchDownloadRight(params)
                if (downRes.code === '1') {
                    const fileIdList = params.list.map((item) => item.fileId).join(',')
                    const reqParams = {
                        token: downRes.data,
                        siteId: this.getSite.siteId,
                        fileIdList
                    }
                    this.$refs.FileConfirmModal.visible = false

                    downloadBatchFiles('/file/free/downloadExMultipleFilesAsZip', reqParams,size)
                    
                } else {
                    this.$message.error(res.errDetails.msg)
                }
            } catch (e) {
                this.$message.error(e.message)
            } finally {
                this.fileDownloading = false
                this.$refs.FileConfirmModal.visible = false
                this.$refs.exchangeTable.clearSelection()
                this.chooseable = false
            }
        },

        // 抽屉
        onDrawClick() {
            if (this.activeTab == '3') {
                this.$refs.ITA.onEntitySelect()
            } else {
                this.pagination.pageNum = 1
                this.getTableList()
            }
        },
        handleStatusChange(row, newStatus) {
            API.exchange
                .changeStatus({
                    bindIdList: [row.id],
                    status: newStatus,
                    siteId: this.getSite.siteId
                })
                .then((res) => {
                    if (res.code == '1') {
                        row.oriStatus = newStatus
                        row.status = newStatus
                        this.$message.success(this.$t('msg_success'))
                    } else {
                        row.status = row.oriStatus
                        this.$message.error(this.$t(res.code))
                    }
                })
        },
        getBehavior() {
            API.common.queryBehavior().then((res) => {
                if (res.code === '1') {
                    this.updateGuide = res.data.jointWorkNoticeReadFlag === 0
                    if (this.updateGuide) this.updateGuideStep = 1
                } else {
                    this.$message.error(this.$t(res.code))
                }
            })
        },
        nextClick() {
            this.activeChange('3')
            this.updateGuideStep = 2
        },
        gotItClick() {
            let param = {
                jointWorkNoticeReadFlag: 1
            }
            API.common.updateBehavior(param).then((res) => {
                if (res.code === '1') {
                    this.updateGuide = false
                    this.updateGuideStep = 0
                } else {
                    this.$message.error(this.$t(res.code))
                }
            })
        },
        updateGuideClass({ row, column, rowIndex, columnIndex }) {
            if (this.updateGuide && this.updateGuideStep === 1 && [1, 2, 3].includes(columnIndex)) {
                return 'updateGuideHeaderTitle'
            }
            return ''
        },
        openEntity() {
            this.$refs.entityRef.updateDrawer()
        }
    }
}
</script>

<style scoped>
::v-deep .exchange-table .el-table__body-wrapper {
    height: calc(100% - 44px) !important;
}
.wl-container {
    height: 100%;
    background: #eff1f5;
    padding: 22px;
}

.wl-content-container {
    background: #fff;
    height: 100%;
    padding: 10px 22px;
    border-radius: 8px;
}
.tab-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    /* border-bottom: 1PX solid #e3e4e6; */
}
.clear-filter {
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    font-size: 12PX;
}

.clear-filter img {
    margin-right: 5px;
}
.tab-cls {
    display: flex;
    list-style: none;
    justify-content: flex-start;
    align-items: flex-start;
    height: 38PX;
}
.tab-cls li {
    margin-right: 10px;
    background-color: #ccced2;
    height: 28PX;
    line-height: 28PX;
    border-radius: 14PX;
    color: #fff;
    font-size: 14PX;
    padding: 0 30px;
    cursor: pointer;
}
.tab-cls li.active {
    background-color: #3879eb;
}
.GuidanceTooltip {
    margin-left: 5px;
}

.search-row,
.bar-row {
    height: 35PX;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
}
.search-row .el-button,
.bar-row .el-button {
    height: 30PX;
    border-radius: 5px;
}
.left {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.search-item {
    margin-right: 20px;
    width: 260px;
}
.search-item .el-date-editor.el-input {
    width: 260px;
}

.wl-search-bar {
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
.ITA-container {
    height: calc(100% - 40PX);
}
.table-container-wrapper {
    margin-top: 5PX;
    height: calc(100% - 113PX - 49px);
    position: relative;
}
.table-container-wrapper.show-table-bottom-operate {
    height: calc(100% - 113PX - 99px);
}
.wl-icon-messageBoard {
    font-size: 18px;
    color: #3879eb;
    cursor: pointer;
}

.wl-icon-messageBoardNull {
    color: #c0c4cc;
    font-size: 18px;
    cursor: pointer;
}

.upload-forbid {
    cursor: not-allowed;
}

.file-number-hint {
    display: block;
    margin-right: 10px;
    width: 100%;
    cursor: pointer;
    user-select: none;
    color: blue;
    text-decoration: underline;
}

.wl-icon-no-delete {
    color: #c0c4cc;
    font-size: 18px;
    cursor: pointer;
}

.wl-icon-no-edit {
    color: #c0c4cc;
    font-size: 18px;
    cursor: pointer;
}

.wl-icon-record {
    color: #1aa0a0;
    font-size: 18px;
    cursor: pointer;
}

.input-with-select {
    width: 260px;
    margin-right: 12px;
}

.wl-overflow-tooltip {
    overflow: hidden;
    display: inline-block;
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.template-uploader {
    margin-left: 10px;
}

.wl-green {
    height: 32px;
}
.mgr10 {
    margin-right: 10PX;
}
.footer-btn {
    height: 50px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
::v-deep .el-pagination .el-select .el-input {
    width: 150px;
}
.header-with-popup {
    display: flex;
    flex-direction: row;
    justify-content: center;
}
.updateGuide {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.5;
    background: #000;
    z-index: 2001;
}
.updateGuideTab {
    z-index: 2002;
    position: relative;
}
.updateGuideTab .updateGuideTip {
    z-index: 2002;
    background-color: #3879eb;
    padding: 20px;
    color: white;
    position: absolute;
    left: 0;
    top: 38PX;
    width: 240PX;
    font-size: 14PX;
    text-align: left;
    border-radius: 10px;
    line-height: normal;
    font-size: 12px;
    line-height: normal;
}
.margin-bottom-10 {
    margin-bottom: 10PX;
}
.guide-btn {
    float: right;
    color: #3879eb;
}
.updateGuideTitle {
    position: absolute;
    background-color: white;
    /*height: 30PX;*/
    width: calc(100% - 400PX - 180PX - 150PX);
    z-index: 2002;
    border: 2PX solid #3879eb !important;
    border-radius: 10px;
    left: 400PX;
}
</style>
<style>
.updateGuideHeaderTitle .cell {
    z-index: 2002;
}
</style>
